var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUpdateunlike(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.078 8.85165H14.7917L15.9486 5.95936C16.2866 5.11698 16.0902 4.15414 15.4484 3.5124C14.7767 2.84159 13.6882 2.84206 13.0174 3.5138C12.9508 3.58037 12.8899 3.65209 12.8355 3.7285L9.74447 8.0538C9.2832 8.69789 8.7699 9.30401 8.2102 9.86465L7.22016 10.8547C7.12922 10.9456 7.07812 11.0689 7.07812 11.1978V18.639C7.07812 18.7679 7.12922 18.8917 7.22016 18.9831L8.32926 20.0974C8.89975 20.6711 9.67603 20.9927 10.4851 20.9903H16.5111C17.4833 20.9894 18.3637 20.417 18.7593 19.5292L21.7154 12.8779C21.9043 12.4536 22.0018 11.9943 22.0004 11.5297V10.7755C21.9994 9.71371 21.1392 8.85305 20.0775 8.85118L20.078 8.85165Z",
    stroke: "#3B72C4",
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.74709 10.204C2.78237 10.204 2 10.9864 2 11.9511V18.5204C2 19.4851 2.78237 20.2675 3.74709 20.2675C4.71181 20.2675 5.49418 19.4851 5.49418 18.5204V11.9511C5.49418 10.9864 4.71181 10.204 3.74709 10.204Z",
    stroke: "#3B72C4",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpdateunlike);
export default __webpack_public_path__ + "static/media/updateunlike.8d713ff2bb7974879e4885c7d9499e2b.svg";
export { ForwardRef as ReactComponent };